import script from "./BasicsDemo.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicsDemo.vue?vue&type=script&setup=true&lang=js"

import "./BasicsDemo.vue?vue&type=style&index=0&id=2792dc71&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2792dc71"]])

export default __exports__